/**
 * EntityTypeEntityDropdownSearchSearches Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
// @ts-ignore
import { selectEntityTypes } from '../../../../services/entityTypes/selectors';

// Utils
// @ts-ignore
import orderBy from '../../../../utils/custom-orderBy';

interface Props {
    limit?: number;
    offset?: number;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
const selectLimit = (state: any, props: Props): number | undefined =>
    props.limit;
const selectOffset = (state: any, props: Props): number | undefined =>
    props.offset;

const selectData = createDeepEqualSelector(
    selectEntityTypes,
    (entityTypesState: Record<string, any>) =>
        entityTypesState && Object.values(entityTypesState)
);

const selectFilteredData = createDeepEqualSelector(
    selectData,
    dataState => dataState
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'depth')
);

const selectSplicedData = createDeepEqualSelector(
    [selectOrderedData, selectLimit, selectOffset],
    (orderedDataState, limitState, offsetState) => {
        if (!limitState && !offsetState) return orderedDataState;
        const begin = offsetState;
        // @ts-ignore
        const end = offsetState + limitState;
        return orderedDataState.slice(begin, end);
    }
);

const selectIds = createDeepEqualSelector(selectSplicedData, splicedDataState =>
    splicedDataState.map((value: Record<string, any>) => value.id)
);

export {
    selectIds,
    selectData,
    selectFilteredData,
    selectOrderedData,
    selectSplicedData
};
